export function constructPromoObject(bonus){
    return bonus ? bonus.map(item => ({
        PromoBetId: item.BalanceId,
        PromoBetCnt: item.RemainingCredits,
        PromoBetValue: item.CreditValues,
        BalanceAmount: item.RemainingValue,
        CampaignId: item.CampaignId,
        PlayerRejectable: false,
        ExpireDate: item.Expires
    })) : null;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/mapper.js